import { memo } from 'react';
import './alva-root.css';

export const AlvaRoot = memo((props) => {
  const { children } = props;
  return children;
});
